/**
 * Removes Brevo/email tracking text accidentally appended to a query param value.
 * e.g. "IvJUiieeL8&utm_source=brevo..." -> "IvJUiieeL8"
 */
export function stripEmailTracking(value) {
    if (!value) return value;
    const i = value.indexOf('&');
    return i !== -1 ? value.substring(0, i) : value;
}

/** Removes Brevo UTM query string from a full page URL (e.g. reset-password links). */
export function stripTrackingFromUrl(href) {
    if (!href) return href;
    const q = href.indexOf('?');
    return q !== -1 ? href.substring(0, q) : href;
}
